import React, {useContext, useEffect} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';

import {Button, message, Space, Tabs} from 'antd';
import {IoArrowBackOutline} from 'react-icons/all';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {Provider, RequestContext} from '../RequestContext';
import RequestInfo from './RequestInfo';
import OrderList from '../../Orders/OrderList';
import MedicationInfo from '../../Medications/MedicationInfo';
import TreatmentList from '../../Patient/Detail/Treatments/TreatmentList';

import {findRequestById} from 'services/RequestService';
import {handleError} from 'utils/MessageUtils';
import DiagnosticInfo from './DiagnosticInfo';

const DetailTab = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const requestContext = useContext(RequestContext);
  const {selectedRequest, setSelectedRequest} = requestContext;

  useEffect(() => {
    if (id) {
      findRequestById(headers, id)
        .then((res) => {
          setSelectedRequest(res.data);
        })
        .catch((error) => handleError(message, error));
    }
  }, [id]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      <AppsContainer
        title={intl.messages['request.info']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoArrowBackOutline />}
                onClick={() => navigate('/health/requests')}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <Space
            direction='vertical'
            style={{width: '100%', paddingLeft: 10, paddingRight: 10}}>
            <Tabs
              defaultActiveKey={view ? view : 'detail'}
              destroyInactiveTabPane={true}>
              <Tabs.TabPane tab={intl.messages['common.detail']} key='detail'>
                <RequestInfo />
              </Tabs.TabPane>
              <Tabs.TabPane tab={intl.messages['request.orders']} key='orders'>
                <OrderList requestId={selectedRequest?.id} />
              </Tabs.TabPane>
              <Tabs.TabPane tab={intl.messages['diagnostic']} key='diagnostic'>
                <DiagnosticInfo requestId={selectedRequest?.id} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['medications']}
                key='medications'>
                <MedicationInfo requestId={selectedRequest?.id} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['treatment.list']}
                key='treatments'>
                <TreatmentList patientId={selectedRequest?.patient?.id} />
              </Tabs.TabPane>
            </Tabs>
          </Space>
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default function RequestDetail() {
  return (
    <Provider>
      <DetailTab />
    </Provider>
  );
}
